// extracted by mini-css-extract-plugin
export default {"titleText":"gSD1lyGrlJQMR2N4ZpWo","nestedCountButton":"itzLprvJNmk8WJX7mrTO"};